import React, { useState, useEffect, useRef } from "react";
import { getClinicalAnalysis } from "../Api"; // Assuming the path to Api.js is correct

const OnboardingStep7 = ({ handleNext }) => {
  const [responseMessage, setResponseMessage] = useState(null);
  const [loadingMessage, setLoadingMessage] = useState("");
  const messageSets = [
    [
      "Recovery takes time—so does getting you the best answer!",
      "Checking this against your journey…",
      "Hang tight...",
      "Almost there…",
      "Here we go!",
    ],
    [
      "Every step counts—including this one!",
      "Lining this up with your journey…",
      "Hold on, double-checking…",
      "Almost ready…",
      "I got this!",
    ],
    [
      "Knees need patience—so do great answers!",
      "Piecing this together just for you…",
      "Hang tight, almost there…",
      "A few more seconds…",
      "And voilà!",
    ],
    [
      "I've got you—let's make this count!",
      "Tailoring this to your recovery…",
      "Just about ready…",
      "Hang tight!",
      "Here it is!",
    ],
    [
      "Your recovery, your pace—let's do this right!",
      "Aligning this with your personal goals…",
      "Fine-tuning for you…",
      "Locking in the best insights!",
      "All set!",
    ],
  ];

  // Use a ref to ensure clinical_analysis is only called once
  const hasFetched = useRef(false);

  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;

    const data = {
      patient_name: localStorage.getItem("patient_name") || "",
      which_knee: localStorage.getItem("which_knee") || "",
      is_preventive: localStorage.getItem("is_preventive") === "true",
      pain_level: parseInt(localStorage.getItem("pain_level")) || "",
      motivation: parseInt(localStorage.getItem("motivation")) || "",
      activity_level: parseInt(localStorage.getItem("activity_level")) || "",
      personal_goal: localStorage.getItem("personal_goal") || "",
      surgery_date: localStorage.getItem("day_zero") || null,
      onset_of_pain: localStorage.getItem("onset_of_pain") || "",
      gender: localStorage.getItem("gender") || "",
      age: parseInt(localStorage.getItem("age")) || "",
    };

    const fetchData = async () => {
      try {
        const result = await getClinicalAnalysis(data);
        if (result && result.recovery_cohorts !== undefined) {
          localStorage.setItem("recovery_cohorts", JSON.stringify(result.recovery_cohorts));
        }
        const formattedMessage = result.message
          .replace(/^### (.*?)$/gm, "<h3>$1</h3>")
          .replace(/^-- in javascript.*$/gm, "")
          .replace(/^\*\*(.*?)\*\*/gm, "<strong>$1</strong>")
          .replace(/\*(.*?)\*/gm, "<em>$1</em>")
          .replace(/^- (.*?)$/gm, "<li>$1</li>")
          .replace(/<li>/, "<ul><li>")
          .replace(/<\/li>(?![\s\S]*<\/li>)/, "</li></ul>")
          .replace(/html/g, "");
        setResponseMessage(formattedMessage);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    const selectedSet =
      messageSets[Math.floor(Math.random() * messageSets.length)];
    let messageIndex = 0;
    const lastMessageIndex = selectedSet.length - 1;

    function updateLoadingMessage() {
      if (messageIndex <= lastMessageIndex) {
        setLoadingMessage(selectedSet[messageIndex]);
        messageIndex++;
        const randomInterval = Math.random() * 1500 + 3000;
        setTimeout(updateLoadingMessage, randomInterval);
      }
    }

    updateLoadingMessage();
    fetchData();
  }, []); // Ensure fetchData is only called once by using an empty dependency array

  const handleNextWithStorage = () => {
    handleNext();
  };

  return (
    <div className="modal-container animated-onboarding saving-container fadeIn">
      {!responseMessage && (
        <>
          <div className="modal-container-title heading fade1">
            <h3 className="loading-message">{loadingMessage}</h3>
          </div>
          <div className="video-container">
            {/* <video src="../videos/rippleEffect.mp4" autoPlay loop></video> */}
            <div className="ripple-container">
              <div className="ripple"></div>
              <div className="ripple"></div>
              <div className="ripple"></div>
              <div className="ripple"></div>
            </div>
          </div>
        </>
      )}
      {responseMessage && (
        <div
          className="response-message"
          dangerouslySetInnerHTML={{ __html: responseMessage }}
          onScroll={(e) => {
            const { scrollTop, scrollHeight, clientHeight } = e.target;
            if (scrollTop + clientHeight >= scrollHeight - 10) {
              document.querySelector(".nav-container").style.display = "block";
            }
          }}
          onTouchEnd={(e) => {
            const { scrollTop, scrollHeight, clientHeight } = e.target;
            if (scrollTop + clientHeight >= scrollHeight - 10) {
              document.querySelector(".nav-container").style.display = "block";
            }
          }}
          style={{ overflowY: "auto", maxHeight: "600px", padding: "10px" }} // Adjust maxHeight and padding as needed
        ></div>
      )}
      {responseMessage && (
        <div className="nav-container transitioning-button fade-fast" style={{ display: "none" }}>
          <button className="btn-next next-btn" onClick={handleNextWithStorage}>
            Let's Go!
          </button>
        </div>
      )}
    </div>
  );
};

export default OnboardingStep7;
